import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss']
})
export class HealthComponent implements OnInit {
  health:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.health=this.facultyService.getPhysical();
  }

}
